import React, { useMemo } from "react";
import { IUserInfoTeam } from "@microdoing/shared/services/team/types";
import theme from "app/Theme/Theme";
import normalize from "app/utils/normalize";
import { Box, MainText, PressableOpacity } from "app/components/common";
import MultipleAvatars from "./MultipleAvatars";
import FlashIcon from "app/components/Icons/FlashIcon";

interface IProps {
  points: number;
  teamName: string;
  rank: number;
  isUserTeam: boolean;
  users: IUserInfoTeam[];
  onPress: () => void;
}

const TeamRankingRow = ({
  points = 4,
  teamName = "",
  rank = 1,
  onPress,
  isUserTeam = false,
  users = [],
}: IProps) => {
  const chunkTeams = useMemo(() => {
    var results = [...users];

    results = results.splice(0, results.length <= 5 ? 5 : 4);
    return results;
  }, [users, users.length]);

  return (
    <PressableOpacity onPress={onPress}>
      <Box
        flex={1}
        marginHorizontal="xm"
        paddingHorizontal="xs"
        borderRadius={8}
        paddingVertical="m"
        flexDirection="row"
        alignItems="center"
        backgroundColor={isUserTeam ? "brand.50" : "neutral.white"}
      >
        <Box flex={1} flexDirection="row" alignItems="center" marginRight="xs">
          <MainText variant="l3-medium" marginRight="xm" color="neutral.600">
            {rank}
          </MainText>
          {!!teamName && (
            <Box width="80%">
              <MainText
                variant={isUserTeam ? "l5-bold" : "l5-medium"}
                numberOfLines={1}
              >{`${teamName}`}</MainText>
            </Box>
          )}
        </Box>
        <Box flexDirection="row" justifyContent="space-between">
          <MultipleAvatars
            avatars={chunkTeams}
            size={normalize(24)}
            maxNumberOfAvatars={2}
          />
          <Box
            marginLeft="m"
            alignItems="center"
            justifyContent="flex-end"
            flexDirection="row"
          >
            <MainText variant="l4-medium" marginRight="xxs" color="neutral.900">
              {points}
            </MainText>
            <FlashIcon
              width={normalize(16)}
              height={normalize(16)}
              color={theme.colors["brand.500"]}
            />
          </Box>
        </Box>
      </Box>
    </PressableOpacity>
  );
};

export default TeamRankingRow;
